/*
 * Smooth Scroll on anchors
 * https://stackoverflow.com/questions/4198041/jquery-smooth-scroll-to-an-anchor
 */
'use strict';

jQuery($ => {
	var hashTagActive = '';
	$('.scroll').on('click touchstart' , function (event) {
		if (hashTagActive !== this.hash) { //this will prevent if the user click several times the same link to freeze the scroll.
			event.preventDefault();
			//calculate destination place
			var dest = 0;
			var anchor = $(this.hash);
			if (anchor.offset().top > $(document).height() - $(window).height()) {
				dest = $(document).height() - $(window).height();
			} else {
				dest = anchor.offset().top;
			}
			//go to destination
			$('html,body').animate({
				scrollTop: dest
			}, 700);
			hashTagActive = this.hash;
		}
	});
});